enum RuleType {
  ALERT = 'ALERT',
  DISABLE_QUESTIONS = 'DISABLE_QUESTIONS',
  SELECTION_ALERT = 'SELECTION_ALERT',
  NOTIFICATION = 'NOTIFICATION',
}

export default RuleType;
